'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DataTrackEventExtractor;

function DataTrackEventExtractor(dataTrackEvent) {
  var target = dataTrackEvent.target;
  var text = target.text;
  var _target$dataset = target.dataset,
      track = _target$dataset.track,
      trackLinkClick = _target$dataset.trackLinkClick,
      trackButtonPress = _target$dataset.trackButtonPress,
      trackLocation = _target$dataset.trackLocation,
      trackCarousel = _target$dataset.trackCarousel;
  var properties = {};

  if (trackLinkClick && trackLocation) {
    properties.location = trackLocation;
    properties.id = trackLinkClick;
    properties.message = text;
    return {
      name: 'link_click',
      properties: properties
    };
  }

  if (trackButtonPress && trackLocation) {
    properties.location = trackLocation;
    properties.id = trackButtonPress;
    properties.message = text;
    return {
      name: 'button_press',
      properties: properties
    };
  }

  if (trackCarousel && trackLocation) {
    properties.location = trackLocation;
    properties.id = trackCarousel;
    return {
      name: 'carousel',
      properties: properties
    };
  }

  return {
    name: track,
    properties: properties
  };
}